
export default class FetchObserver {
  constructor(response, request) {
    this.response = response
    this.request = request
  }
}
